import { Injectable, signal } from '@angular/core';

/**
 * Service that manages the navigation state, particularly for mobile sidenav control
 */
@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  // State for mobile sidenav toggle
  readonly #mobileNavOpened = signal(true);

  /**
   * Get the current mobile navigation opened state
   */
  get mobileNavOpened() {
    return this.#mobileNavOpened.asReadonly();
  }

  /**
   * Toggle mobile sidenav open/closed state
   */
  toggleMobileNav(): void {
    this.#mobileNavOpened.update(current => !current);
  }

  /**
   * Close mobile sidenav
   */
  closeMobileNav(): void {
    this.#mobileNavOpened.set(false);
  }

  /**
   * Open mobile sidenav
   */
  openMobileNav(): void {
    this.#mobileNavOpened.set(true);
  }
}
